import React, {useLayoutEffect, useState} from 'react';
import styles from './styles';
import {Button, DynamicSelect} from '@xpertdox_js/xdcomponents';
import {ScrollContext} from '../Utils/ScrollContext';
import {DragTableContext} from '../Utils/DragTableContext';
import Scrollbar from './Scrollbar';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

const BottomToolbar = props => {

  const {bottomToolbar, scrollEffect} = React.useContext(ScrollContext);
  const {draggable} = React.useContext(DragTableContext);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  useLayoutEffect(() => scrollEffect());
  const controller = props.controller;


  // user page input state
  const [input, setInput] = useState(controller.page + 1);

  const handlePagify = (pageIndex) => {
    controller.page = pageIndex;
    controller.pagifyData();
    controller.render();
  }
  const handleLimitChange = (limit) => {
    controller.pageLimit = limit;
    controller.pagifyData();
    controller.render();
  }

  // activity log
  const handleActivityLogUpdate = (_id) => trackActivity({body: {
      _id,
      instance: contextInstance || user.instance,
      user: user.id
    }
  })

  const handlePageUp = () => {
    handleActivityLogUpdate(`BottomToolbar.handlePageUp`)
    if (controller.page + 1 < props.total) {
      setInput(controller.page + 2)
      handlePagify(controller.page + 1);
    }
  }
  const handlePageDown = () => {
    handleActivityLogUpdate(`BottomToolbar.handlePageDown`)
    if (controller.page - 1 >=0) {
      setInput(controller.page)
      handlePagify(controller.page - 1);
    }
  }

  // user page input type event
  const handleInput = (e) => setInput(
    e.target.value.length && parseInt(e.target.value)
    ? parseInt(e.target.value)
    : ''
  );

  // user page input subnmit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      input !== controller.page
      && input - 1 >= 0
      && input <= props.total
    ) {
      handlePagify(input - 1);
      setInput(input);
    }
  }

  // change page limit
  const handleLimitSelect = (limit) => {
    handleLimitChange(parseInt(limit))
    handleActivityLogUpdate(`BottomToolbar.handleLimitSelect.(${limit})`)
  }
  // check to make sure page is inside limit
  if (input > props.total && props.total) {
    setInput(props.total)
    handlePagify(props.total >= 1 ? props.total - 1 : 0)
  }
  if (input !== controller.page + 1) setInput(controller.page + 1);

  const total = controller.filteredData
    ? controller.filteredData.length
    : controller.data
    ? controller.data.length
    : 0;

  const startIndexOfList = props.pageTotal === 0 ? 0
  : input -1 <= 0 ? 1
  : props.pageTotal !== 10 && props.pageTotal !== 20 && props.pageTotal !== 40 && props.pageTotal !== 30 ? (props.data.length + 2) - props.pageTotal
  : (input - 1) * props.pageTotal + 1;

  return(
    <React.Fragment>
      <div style={{
        ...styles.container,
        width: props.width,
        position: bottomToolbar ? 'fixed' : 'absolute',
        boxShadow: bottomToolbar ? '0 -10px 6px -6px rgba(0,0,0,0.12)' : 'none',
        transition: 'width .18s ease-out',
      }}>
        {draggable &&
          <Scrollbar
            scrollbarWidth={props.scrollbarWidth}
            controller={props.controller}
          />
        }
        <div style={styles.toolbarContent}>
          {/* PageLimit Container */}
          <div style={styles.pageLimitContainer}>
            <DynamicSelect
              options={[10, 20, 30, 40]}
              setter={handleLimitSelect}
              styles={styles.pageLimit}
              placeholder={'Page Limit'}
              selected={controller.pageLimit}
            />
          </div>
          {/* count container */}
          <div style={styles.pageCountContainer}>
            {//<span>Showing {startIndexOfList} - {input !== props.total ? input * props.pageTotal : controller.data ? controller.data.length + 1 : 0 } of {props.pageTotal === 0 ? 0 : total + 1}</span>
            }
            <span>{props.pageTotal === 0 ? 0 : total} Results</span>
          </div>
          {/* Pagify Container */}
          <div style={styles.pageifyContainer}>
            { startIndexOfList !== 1
              ? <Button
              onClick={handlePageDown}
              styles={styles.pagifyBtn}
              hoverStyles={styles.pagifyBtnHov}
              activeStyles={styles.pagifyBtnAct}
              focusStyles={styles.pagifyBtnHov}
            >
              <svg style={styles.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"/></svg>
            </Button>
              : ''
            }
            <div style={styles.inputWrap}>
              <form onSubmit={handleSubmit} style={styles.inputForm}>
                <input
                  id='dt_pagify_input'
                  onChange={handleInput}
                  value={input === 0 ? 1 : input}
                  style={styles.input}
                />
            </form><span style={styles.count}> / {props.total || 1}</span>
            </div>
            { controller.page + 1 !== props.total
             ?  <Button
                  onClick={handlePageUp}
                  styles={styles.pagifyBtn}
                  hoverStyles={styles.pagifyBtnHov}
                  activeStyles={styles.pagifyBtnAct}
                  focusStyles={styles.pagifyBtnHov}
                >
                <svg style={styles.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>
                </Button>
              : ''
            }
          </div>
        </div>
      </div>

    </React.Fragment>
  )
}

export default BottomToolbar
